import type { UnavailableArtifact } from "~/helpers/aiChat/chatStorage";

import { Box, Button, Icon } from "@mui/material";

import FernieCardHeader from "~/components/FernieCardHeader";
import FernieCardShell from "~/components/FernieCardShell";
import { BodyTextSmall, CaptionText } from "~/components/Typographies";

interface FernieExpiredReportCardProps {
	artifact: UnavailableArtifact;
	onRegenerate: () => void;
}

const FernieExpiredReportCard = ({ artifact, onRegenerate }: FernieExpiredReportCardProps) => (
	<FernieCardShell accent="neutral" branded>
		<FernieCardHeader accent="primary" branded pillLabel="Report" />

		<Box sx={{ alignItems: "center", display: "flex", gap: 1, pt: 1.25, px: 2 }}>
			<Icon sx={{ color: "text.disabled", fontSize: 18 }}>history_toggle_off</Icon>
			<CaptionText
				sx={{
					color: "text.secondary",
					flex: 1,
					fontWeight: 500,
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap"
				}}
			>
				{artifact.filename}
			</CaptionText>
		</Box>

		<CaptionText sx={{ color: "text.secondary", display: "block", lineHeight: 1.5, pt: 0.75, px: 2 }}>
			This report is no longer available. Regenerate it to open or export it again.
		</CaptionText>

		<Box sx={{ display: "flex", pb: 1.75, pt: 1.5, px: 2 }}>
			<Button
				color="primary"
				onClick={onRegenerate}
				startIcon={<Icon sx={{ fontSize: 16 }}>refresh</Icon>}
				sx={{ borderRadius: "8px", flex: 1, py: 0.85, textTransform: "none" }}
				variant="contained"
			>
				<BodyTextSmall bold sx={{ color: "inherit" }}>
					Regenerate report
				</BodyTextSmall>
			</Button>
		</Box>
	</FernieCardShell>
);

export default FernieExpiredReportCard;
